import React from 'react'
import VendorStationContainer from "containers/VendorDetails"


function VendorStation() {
  return (
    <div>
        <VendorStationContainer />
    </div>
  )
}

export default VendorStation